import { Pipe, PipeTransform, NgModule } from '@angular/core';
import * as moment from 'moment';
import { Moment } from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { SharedService } from '../services/shared.service';
import { languageEnum } from '../enum-files/languageEnum';

@Pipe({ name: 'timeformatslots', pure:false })
export class TimeFormatPipeSlots implements PipeTransform {
  public currentLang;
  constructor(private translate: TranslateService,
    private sharedService: SharedService){
      if(this.sharedService.isExternal){
        if(this.sharedService.externalLang == languageEnum.Dutch){
          this.currentLang = "nl-NL";
        }else if(this.sharedService.externalLang == languageEnum.English){
          this.currentLang = "en-US";
        }else if(this.sharedService.externalLang == languageEnum.Polish){
          this.currentLang = "pl-PL";
        }else {
          this.currentLang = "de-DE";
        }
      }else{
        this.currentLang = localStorage.getItem("language-slots");
      }
  }
  transform(value, fromFormat, toFormat): any {
    if (!value) return value;
    let momentLang:string = "nl";
    if(this.currentLang && this.currentLang !== "nl-NL"){
      momentLang = this.currentLang.split("-")[0];
    }
    
    if(fromFormat == 'date' || fromFormat == 'js_date' || fromFormat == 'js_date_1'){
      return moment(value).locale(momentLang).format(toFormat);
    }
    else{
      return moment(value, fromFormat).format(toFormat);
    }
  
  }
}

@NgModule({
  imports: [
    // dep modules
  ],
  declarations: [ 
    TimeFormatPipeSlots
  ],
  exports: [
    TimeFormatPipeSlots
  ]
})
export class TimeFormatForSlots {}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/TimeFormatPipeSlots.ts